import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { of } from "rxjs/internal/observable/of";
import { map } from "rxjs/operators";

import { environment } from "src/environments/environment";
import HttpStatusCode from "../_enums/HttpStatusCode";
import { IConfiguration } from "../_models/configuration/IConfiguration";

@Injectable({
  providedIn: "root",
})
export class ConfigurationService {
  configurations: IConfiguration[] = [];
  publicConfigurations: IConfiguration[] = [];

  constructor(private http: HttpClient) {}

  getConfig(key: string) {
    // caching
    if (this.configurations.length > 0) {
      const config = this.configurations.find((x) => x.key === key);
      if (config !== undefined) {
        return of(config);
      }
      return throwError("Configurarea: " + key + " nu a fost gasita");
    }

    return this.http.get(environment.API_URL + "configurations").pipe(
      map((res: IConfiguration[]) => {
        this.configurations = res;
        if (res.length > 0) {
          const config = res.find((x) => x.key === key);
          if (config !== undefined) {
            return config;
          }
          return throwError("Configurarea: " + key + " nu a fost gasita");
        }
        return throwError("Nu exista configurari");
      })
    );
  }

  getPublicConfig(key: string) {
    // caching
    if (this.publicConfigurations.length > 0) {
      const config = this.publicConfigurations.find((x) => x.key === key);
      if (config !== undefined) {
        return of(config);
      }
      return throwError("Configurarea: " + key + " nu a fost gasita");
    }

    return this.http.get(environment.API_URL + "publicconfigurations").pipe(
      map((res: IConfiguration[]) => {
        this.publicConfigurations = res;
        if (res.length > 0) {
          const config = res.find((x) => x.key === key);
          if (config !== undefined) {
            return config;
          }
          return throwError("Configurarea: " + key + " nu a fost gasita");
        }
        return throwError("Nu exista configurari");
      })
    );
  }

  getConfigurations(publicConfiguration = false) {
    const pc = publicConfiguration ? "public" : "";
    return this.http.get(environment.API_URL + pc + "configurations").pipe(
      map((res: IConfiguration[]) => {
        res.map(x => {
          x.value = x.type === "checkbox" ? ((x.value.toLowerCase() === 'true') ? true : false) : x.value,
          x.valueCopy = x.value;
        });
        return res;
      })
    );
  }

  update(config: IConfiguration, publicConfiguration = false) {
    const pc = publicConfiguration ? "public" : "";
    return this.http
      .put(
        environment.API_URL + pc + "configurations/" + config.id,
        config,
        { observe: "response" }
      )
      .pipe(
        map((res) => {
          return res.status === HttpStatusCode.OK;
        })
      );
  }
}
